(function () {
  if (window.__nestLreCartQuantityPreserve20260707) return;
  window.__nestLreCartQuantityPreserve20260707 = true;

  var cachedCart = null;
  var cacheTimer = null;
  var retryCount = 0;
  var maxRetryCount = 20;
  var eligibleSignals = ['sparrow', 'owl', 'starling', 'raven', 'puffin'];

  function mark(name, detail) {
    if (window.NestLreCartTiming && typeof window.NestLreCartTiming.mark === 'function') {
      window.NestLreCartTiming.mark(name, detail);
    }
  }

  function currentPath() {
    return window.location && window.location.pathname ? window.location.pathname.toLowerCase() : '';
  }

  function targetPage() {
    var path = currentPath();
    return /\/products\/[^/]*(sparrow|owl)[^/]*mattress/.test(path) || /\/products\/starling-signature-contour-grid/.test(path);
  }

  function textOf(item) {
    return [
      item && item.product_title,
      item && item.title,
      item && item.handle,
      item && item.url,
      item && item.product_type,
      item && item.vendor
    ].join(' ').toLowerCase();
  }

  function propsOf(item) {
    return item && item.properties && typeof item.properties === 'object' ? item.properties : {};
  }

  function isMrcFee(item) {
    var props = propsOf(item);
    var title = textOf(item);
    return String(props.type || '').toLowerCase() === 'fee' ||
      title.indexOf('mrc recycling fee') > -1 ||
      title.indexOf('mattress recycling fee') > -1;
  }

  function isLre(item) {
    return textOf(item).indexOf('lifetime renewal exchange') > -1;
  }

  function isExtend(item) {
    var title = textOf(item);
    return title.indexOf('extend protection') > -1 || title.indexOf('protection plan') > -1;
  }

  function isCompanionItem(item) {
    return isMrcFee(item) || isLre(item) || isExtend(item);
  }

  function isEligibleMattress(item) {
    if (!item || Number(item.quantity || 0) <= 0 || isCompanionItem(item)) return false;
    var text = textOf(item);
    if (text.indexOf('mattress') > -1) return true;
    return eligibleSignals.some(function (signal) { return text.indexOf(signal) > -1; });
  }

  function itemByVariant(cart, variantId) {
    var id = Number(variantId);
    return (cart && cart.items || []).find(function (item) {
      return Number(item.variant_id) === id;
    });
  }

  function parseUpdatesFromParams(params) {
    var updates = {};
    params.forEach(function (value, key) {
      var match = String(key).match(/^updates\[(.+?)\]$/);
      if (!match) return;
      updates[match[1]] = Number(value);
    });
    return updates;
  }

  function removedEligibleQty(cart, updates) {
    return Object.keys(updates).reduce(function (sum, variantId) {
      if (updates[variantId] !== 0) return sum;
      var item = itemByVariant(cart, variantId);
      return sum + (isEligibleMattress(item) ? Number(item.quantity || 0) : 0);
    }, 0);
  }

  function rewriteParams(params, reason) {
    if (!targetPage() || !cachedCart || !(cachedCart.items || []).length) return false;

    var updates = parseUpdatesFromParams(params);
    var eligibleRemoved = removedEligibleQty(cachedCart, updates);
    if (eligibleRemoved <= 0) return false;

    var changed = false;
    Object.keys(updates).forEach(function (variantId) {
      if (updates[variantId] !== 0) return;
      var item = itemByVariant(cachedCart, variantId);
      if (!isLre(item)) return;

      var currentQty = Number(item.quantity || 0);
      var nextQty = Math.max(0, currentQty - eligibleRemoved);
      if (currentQty > 1 && nextQty > 0) {
        params.set('updates[' + variantId + ']', String(nextQty));
        changed = true;
        mark('LRE quantity preserved during mattress removal', {
          reason: reason,
          variant_id: Number(variantId),
          current: currentQty,
          next: nextQty,
          eligibleRemoved: eligibleRemoved
        });
      }
    });

    return changed;
  }

  function rewriteUrl(url, reason) {
    if (!targetPage() || typeof url !== 'string' || url.indexOf('/cart/update') === -1 || url.indexOf('updates') === -1) return url;
    try {
      var original = String(url);
      var parsed = new URL(original, window.location.origin);
      if (!/\/cart\/update(?:\.js)?$/i.test(parsed.pathname)) return url;
      if (!rewriteParams(parsed.searchParams, reason || 'url')) return url;
      return /^https?:\/\//i.test(original) ? parsed.toString() : parsed.pathname + parsed.search + parsed.hash;
    } catch (error) {
      return url;
    }
  }

  function rewriteBody(body, reason) {
    if (!targetPage() || !body) return body;

    if (body instanceof URLSearchParams) {
      rewriteParams(body, reason || 'URLSearchParams');
      return body;
    }

    if (window.FormData && body instanceof FormData) {
      var params = new URLSearchParams();
      body.forEach(function (value, key) { params.append(key, value); });
      if (!rewriteParams(params, reason || 'FormData')) return body;
      params.forEach(function (value, key) { body.set(key, value); });
      return body;
    }

    if (typeof body === 'string' && body.indexOf('updates') > -1) {
      try {
        var parsed = new URLSearchParams(body);
        if (rewriteParams(parsed, reason || 'string')) return parsed.toString();
      } catch (error) {}
    }

    if (body && typeof body === 'object' && body.updates && typeof body.updates === 'object') {
      var updates = body.updates;
      var eligibleRemoved = removedEligibleQty(cachedCart, updates);
      if (eligibleRemoved <= 0) return body;
      Object.keys(updates).forEach(function (variantId) {
        if (Number(updates[variantId]) !== 0) return;
        var item = itemByVariant(cachedCart, variantId);
        if (!isLre(item)) return;
        var currentQty = Number(item.quantity || 0);
        var nextQty = Math.max(0, currentQty - eligibleRemoved);
        if (currentQty > 1 && nextQty > 0) {
          updates[variantId] = nextQty;
          mark('LRE quantity preserved during mattress removal', {
            reason: reason || 'object',
            variant_id: Number(variantId),
            current: currentQty,
            next: nextQty,
            eligibleRemoved: eligibleRemoved
          });
        }
      });
      return body;
    }

    return body;
  }

  function updateCartCache(cart, reason) {
    if (!cart || !Array.isArray(cart.items)) return;
    cachedCart = cart;
    mark('LRE preserve cart cache updated', {
      reason: reason,
      item_count: cart.item_count,
      total_price: cart.total_price
    });
  }

  function scheduleCacheRefresh(reason, delay) {
    if (!targetPage() || !window.fetch) return;
    window.clearTimeout(cacheTimer);
    cacheTimer = window.setTimeout(function () {
      window.fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (response) { return response.json(); })
        .then(function (cart) { updateCartCache(cart, reason || 'scheduled'); })
        .catch(function () {});
    }, typeof delay === 'number' ? delay : 250);
  }

  function watchFetchResponse(url, response) {
    if (!targetPage() || !response || typeof response.clone !== 'function') return;
    if (String(url || '').indexOf('/cart.js') === -1) return;
    response.clone().json()
      .then(function (cart) { updateCartCache(cart, 'fetch ' + url); })
      .catch(function () {});
  }

  function patchFetch() {
    if (!window.fetch || window.fetch.__nestLreCartQuantityPreserve20260707) return;
    var originalFetch = window.fetch;
    window.fetch = function () {
      var args = Array.prototype.slice.call(arguments);
      var input = args[0];
      var url = typeof input === 'string' ? input : input && input.url;
      if (typeof args[0] === 'string') args[0] = rewriteUrl(args[0], 'fetch url');
      if (args[1] && Object.prototype.hasOwnProperty.call(args[1], 'body')) args[1].body = rewriteBody(args[1].body, 'fetch body');
      return originalFetch.apply(this, args).then(function (response) {
        watchFetchResponse(url, response);
        if (String(url || '').indexOf('/cart/') > -1) scheduleCacheRefresh('after fetch ' + url, 350);
        return response;
      });
    };
    window.fetch.__nestLreCartQuantityPreserve20260707 = true;
  }

  function patchXhr() {
    if (!window.XMLHttpRequest || window.XMLHttpRequest.prototype.__nestLreCartQuantityPreserve20260707) return;
    var proto = window.XMLHttpRequest.prototype;
    var originalOpen = proto.open;
    var originalSend = proto.send;

    proto.open = function (method, url) {
      var nextUrl = rewriteUrl(String(url || ''), 'xhr url');
      this.__nestLrePreserveUrl20260707 = nextUrl;
      return originalOpen.call(this, method, nextUrl);
    };

    proto.send = function (body) {
      var xhr = this;
      var url = xhr.__nestLrePreserveUrl20260707 || '';
      var nextBody = rewriteBody(body, 'xhr body');
      xhr.addEventListener('loadend', function () {
        if (url.indexOf('/cart.js') > -1) {
          try {
            var parsed = xhr.responseType === 'json' ? xhr.response : JSON.parse(xhr.responseText || 'null');
            updateCartCache(parsed, 'xhr ' + url);
          } catch (error) {}
        }
        if (url.indexOf('/cart/') > -1) scheduleCacheRefresh('after xhr ' + url, 350);
      });
      return originalSend.call(this, nextBody);
    };

    proto.__nestLreCartQuantityPreserve20260707 = true;
  }

  function install() {
    patchFetch();
    patchXhr();
    scheduleCacheRefresh('initial', 0);
    if (!window.fetch || !window.XMLHttpRequest) {
      retryCount += 1;
      if (retryCount < maxRetryCount) window.setTimeout(install, 100);
    }
    mark('LRE cart quantity preserve loaded', currentPath());
  }

  install();
})();
